/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
function e(e){return!!(null!=e&&"object"==typeof e&&"createQuery"in e&&e.createQuery&&"on"in e&&e.on)}export{e as isSelectableLayer};
